module.exports = __webpack_public_path__ + "img/IMG_8629_T_L.384cdf39.webp";